import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0a91f01f"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Kundenkarte")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Gutscheine")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Stempel")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Angebote")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_router_outlet = _resolveComponent("ion-router-outlet")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_tab_button = _resolveComponent("ion-tab-button")!
  const _component_ion_tab_bar = _resolveComponent("ion-tab-bar")!
  const _component_ion_tabs = _resolveComponent("ion-tabs")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      (_ctx.activePartner && _ctx.activePartner.url_path)
        ? (_openBlock(), _createBlock(_component_ion_tabs, { key: 0 }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_router_outlet),
              _createVNode(_component_ion_tab_bar, { slot: "bottom" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_tab_button, {
                    tab: "customer-card",
                    href: '/' + _ctx.activePartner.url_path + '/customer-card',
                    disabled: !_ctx.analyticsAllowed
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_icon, { name: "card-outline" }),
                      _createVNode(_component_ion_label, null, {
                        default: _withCtx(() => [
                          _hoisted_1
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["href", "disabled"]),
                  _createVNode(_component_ion_tab_button, {
                    tab: "coupon",
                    href: '/' + _ctx.activePartner.url_path + '/coupon',
                    disabled: !_ctx.analyticsAllowed
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_icon, { name: "ticket-outline" }),
                      _createVNode(_component_ion_label, null, {
                        default: _withCtx(() => [
                          _hoisted_2
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["href", "disabled"]),
                  _createVNode(_component_ion_tab_button, {
                    tab: "stamp-cards",
                    href: '/' + _ctx.activePartner.url_path + '/stamp-card',
                    disabled: !_ctx.analyticsAllowed
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_icon, { name: "water-outline" }),
                      _createVNode(_component_ion_label, null, {
                        default: _withCtx(() => [
                          _hoisted_3
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["href", "disabled"]),
                  _createVNode(_component_ion_tab_button, {
                    tab: "home",
                    href: '/' + _ctx.activePartner.url_path + '/promotion'
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_icon, { name: "cash-outline" }),
                      _createVNode(_component_ion_label, null, {
                        default: _withCtx(() => [
                          _hoisted_4
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["href"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}